import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  back: any;

  constructor(private location: Location) { }

  Back(): void {
    this.location.back();
  }

}